var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h4", [_vm._v("Select a driver to assign")]),
    _c(
      "div",
      { staticClass: "driver-selection" },
      [
        _c(
          "md-field",
          [
            _c("label", [_vm._v("Driver")]),
            _c(
              "md-select",
              {
                attrs: { "md-no-validate": "" },
                model: {
                  value: _vm.driverIdModel,
                  callback: function ($$v) {
                    _vm.driverIdModel = $$v
                  },
                  expression: "driverIdModel",
                },
              },
              _vm._l(_vm.teamMembers, function (member) {
                return _c(
                  "md-option",
                  {
                    key: member.publicUserId,
                    attrs: { value: member.publicUserId },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(member.firstName) +
                        " " +
                        _vm._s(member.lastName) +
                        "\n                "
                    ),
                  ]
                )
              }),
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }